export default __webpack_public_path__ + "static/media/coming_soon.ac8be43d.png";